import { addDays, isBefore } from "date-fns";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useCallback } from "react";

import { RouteName } from "@/consts";
import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { useAnalytics } from "@/features/common/hooks/useAnalytics";
import { getPublicConfig } from "@/helpers/getPublicConfig";

type UseEditPostButtonArgs = {
  postDetail: {
    createdAt: string;
    slug: string;
  };
  logEvent?: AnalyticsEventEnum;
};

export const useEditPostButton = ({
  postDetail: { createdAt, slug },
  logEvent,
}: UseEditPostButtonArgs) => {
  const { t } = useTranslation("post");
  const config = getPublicConfig();
  const router = useRouter();
  const { trackEvent } = useAnalytics();

  const isEditable = isBefore(
    new Date(),
    addDays(new Date(createdAt), config.features.post.editableInDays),
  );

  const onClickEditPostButton = useCallback(() => {
    trackEvent(logEvent ?? AnalyticsEventEnum.MenuEditPost);

    // if (!isEditable) return alert(t("post:postNotEditableAlert"));
    router.push(`${RouteName.NewPost}/${slug}`);
  }, [slug, isEditable, router, t, logEvent, trackEvent]);

  return {
    editPostLabel: t("post:edit"),
    onClickEditPostButton,
    editPostDisabled: !isEditable,
  };
};
